import api from "@/services/api";

const state = {
  accounts: [],
};

const mutations = {
  SET_ACCOUNTS(state, accounts) {
    state.accounts = accounts;
  },
};

const actions = {
  async getAccounts({ commit }) {
    try {
      const res = await api.get("/accounts");
      commit("SET_ACCOUNTS", res.data);
      return res.data;
    } catch (error) {
      console.error("Error fetching accounts:", error.message);
      throw error;
    }
  },

  async createAccount({ dispatch }, accountData) {
    try {
      const result = await api.post("/accounts", accountData);
      await dispatch("getAccounts");
      return result.data;
    } catch (error) {
      console.error("Error creating account:", error.message);
      throw error;
    }
  },

  async updateAccount({ dispatch }, { id, accountData }) {
    try {
      const result = await api.put(`/accounts/${id}`, accountData);
      await dispatch("getAccounts");
      return result.data;
    } catch (error) {
      console.error("Error updating account:", error.message);
      throw error;
    }
  },

  async deleteAccount({ dispatch }, id) {
    try {
      await api.delete(`/accounts/${id}`);
      await dispatch("getAccounts");
    } catch (error) {
      console.error("Error deleting account:", error.message);
      throw error;
    }
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
